export default "__VITE_ASSET__DyyUNevg__"